
export class SwitcherBoxActivation {
  box1 = false;
  box2 = false;
  box3 = false;
  box4 = false;

  constructor(value: boolean) {
    this.box1 = value;
    this.box2 = value;
    this.box3 = value;
    this.box4 = value;
  }
}

export class SwitcherBoxes {
  dates = new SwitcherDateBoxes();
  numbers = new SwitcherNumberBoxes();
}

export enum SwitcherDateType {
  DAY = 'day',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export enum SwitcherDateNames {
  DAY = 'Day',
  MONTH = 'Month',
  QUARTER = 'Quarter',
  YEAR = 'Year',
}

export enum SwitcherNumberType {
  REGULAR = 1,
  THOUSAND = 1000,
  MILLION = 1000000,
}

export enum SwitcherNumberNames {
  REGULAR = '123',
  THOUSAND = 'K',
  MILLION = 'M',
}

export class SwitcherDateBoxes {
  box1 = SwitcherDateNames.DAY;
  box2 = SwitcherDateNames.MONTH;
  box3 = SwitcherDateNames.QUARTER;
  box4 = SwitcherDateNames.YEAR;
}

export class SwitcherNumberBoxes {
  box1 = SwitcherNumberNames.REGULAR;
  box2 = SwitcherNumberNames.THOUSAND;
  box3 = SwitcherNumberNames.MILLION;
}

export enum SwitcherBoxType{
  NUMBER = 'numbers',
  DATE = 'dates',
}
